<p-toast key="toastmsg" position="top-right"></p-toast>
<!-- <div class="top-bar-notice" *ngIf="isAndroid && !isFullAndroid && isPWAInstalled">
    <div class="button-div">
        To play the money contest, download our app from the <a href="https://tplsport.com/home" class="downloadLink" target="_blank"><b>Website</b></a>
    </div>
</div> -->

<!-- <div class="top-bar-notice" *ngIf="isAndroid && !isFullAndroid && !isPWAInstalled">
    <div class="button-div">
        <a href="../../../assets/tplsport.apk" target="_blank" (click)="onDownloadMoneyContestApp()">
            <button type="button" class="contest-btn-main"> Tap here </button>
        </a>
    </div>
    <div class="title-div">
        <h3>To participate in Money Contest</h3>
    </div>
</div> -->
  <div class="mobile_version-backbutton">
      <a class="mobile-header" onclick="history.back()">
        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span>Contest </a>
    </div>
    <div class="topTitle">
    <h2>Contest</h2>
</div>

   <div class="mainPageTitle  ">
                    <div class="tab-div">
                        <ul class="tabList">
                            <li>
                                <button class="active-btn">
                                    Cash
                                </button>
                            </li>
                            <li>
                                <button >
                                    Coin
                                </button>
                            </li>
                            
                        </ul>
                    </div>
                </div>
<!-- <section class="login-page-section-top ">

    <div class="container">
        <div class="row">
            <div class="col-md-12 size-img back-img">
                <div class="effect-cover">

                    <h3 class="txt-advert animated fadeInUp">CONTESTS </h3>
                    <p class="txt-advert-sub animated">In this world, you get rewarded to watch others play tennis! All
                        you need is some skill and will! You are 1 click away
                        from earning a fortune!
                    </p>
                </div>

            </div>
        </div>
    </div>
    <div *ngFor="let banner of bannerImageList " class="swiper-slide zoom-effect-container banner-image-div">
        <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
            <div class="headings image-card">
                <img [src]="banner.banner_image_src" class="product-image" alt="banner" />
                <div class="slider-inner-div">
                    <div class="container">
                        <div class="main-heading-banner">
                            
                            <div class="sldier-bottom-section"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
 
    <div *ngFor="let banner of webBannerImageList"
        class="swiper-slide zoom-effect-container banner-image-div web-view-banner">
        <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
            <div class="headings image-card">
                <img [src]="banner.banner_image_src" class="product-image" alt="web banner" />
                <div class="slider-inner-div">
                    <div class="container">
                        <div class="main-heading-banner">
                            <div class="sldier-bottom-section"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngFor="let banner of mobileBannerImageList"
        class="swiper-slide zoom-effect-container banner-image-div mobile-view-banner">
        <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
            <div class="headings image-card">
                <img [src]="banner.banner_image_src" class="product-image" alt="mobile banner" />
                <div class="slider-inner-div">
                    <div class="container">
                        <div class="main-heading-banner">
                            <div class="sldier-bottom-section"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mobile_version-backbutton">
        <a class="mobile-header" onclick="history.back()">
          <i class="bx bx-chevron-left" style="color: #fff; font-size: 1.6em;"></i> Back </a>
      </div>
</section> -->
<!-- <section class="breadcrumbs">
    <div class="container">
        <div class="d-flex justify-content-between align-items-center">
            <h2>CONTESTS
            </h2>
            <ol>
                <li><a href="index.html">Home</a></li>
                <li>CONTESTS
                </li>
            </ol>
        </div>
    </div>
</section> -->
<!-- End Breadcrumbs -->
<div class="not-found-section d-none">
    <div class="col-md-12 not-found-body">
        <img src="assets/img/logo/not-found.gif" alt="">
        <h4>Coming Soon!</h4>
        <p>{{comingSoonMsg}}</p>

    </div>
</div>
<section class="contest-lists-section">
    <div class=" container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
                <div class="col-md-3  leftFilters-div">
                <div class="filter-sidebar">
                    <div class="filter-header">
                        <span class="filter-title">Filters</span>
                        <a class="clear-filter"  >Clear filter</a>
                    </div>
                    <p-accordion [multiple]="true" class="filter-accordion" [activeIndex]="[0,2]">
                        <p-accordionTab header="State">
                          <div class="filterBody">
                            <div class="filterHeader">
                              <div class="searchbar">
                                <input pInputText type="text" placeholder="Search for State"  
                                  class="search-input" />
                                <div class="icon">
                                  <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                                </div>
                              </div>
                            </div>
                            <div class="filterMainList">
                              <div   class="filterList">
                                <p-checkbox ></p-checkbox>
                                <label for="selectedAges">No State Available</label>
                              </div>
                            </div>
                          </div>
                        </p-accordionTab>

                        <p-accordionTab header="City">
                          <div class="filterBody">
                            <div class="filterHeader">
                              <div class="searchbar">
                                <input pInputText type="text" placeholder="Search for City"  
                                  class="search-input" />
                                <div class="icon">
                                  <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                                </div>
                              </div>
                            </div>
                            <div class="filterMainList">
                              <div   class="filterList">
                                <p-checkbox  ></p-checkbox>
                                <label for="selectedAges">No City Available</label>
                              </div>
                            </div>
                          </div>
                        </p-accordionTab>

                      
                        <!-- <p-accordionTab header="Month">
                <div class="filterBody">
                  <div class="filterMainList">
                    <div *ngFor="let  month of monthlist" class="filterList">
                      <p-checkbox [value]="month" [binary]="false"></p-checkbox>
                      <label for="selectedAges">{{month }}</label>
                    </div>
                  </div>
                </div>
              </p-accordionTab>
              <p-accordionTab header="Date">
                <div class="filterBody dateRange">
                  <div class="filterMainList">
                    <div class="d-flex">
                      <p-calendar [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"
                        dateFormat="dd/mm/yy" appendTo="body" placeholder="Select Date" (onSelect)="selectDateRange()">
                      </p-calendar>
                      <button pButton label="Clear" title="Clear" class="p-button p-ml-2 p-mb-0" style="color: #fff!important;
                    padding: 6px 0px;
                    width: 30%" (click)="clear()"></button>
                    </div>
                  </div>
                </div>
              </p-accordionTab>
              <p-accordionTab header="Surface">
                <div class="filterBody">
                  <div class="filterHeader">
                    <div class="searchbar">
                      <input pInputText type="text" placeholder="Search for surface" [(ngModel)]="ageFilter"
                        class="search-input" />
                      <div class="icon">
                        <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="filterMainList">
                    <div *ngFor="let court of courtTypeList" class="filterList">
                      <p-checkbox [value]="court" [binary]="false"></p-checkbox>
                      <label for="selectedAges">{{ court.label }}</label>
                    </div>
                  </div>
                </div>
              </p-accordionTab> -->
                    </p-accordion>

                    <!-- <div class="fliter-div">

                        <div class="col-md-12">
                            <h6>Select State</h6>
                        </div>

                        <div class="sellers d-flex">
                            <p-dropdown inputId="state" [showClear]="true" [options]="states" placeholder="Select"
                                [filter]="true" (onChange)="setState($event)" optionLabel="name"
                                (onClear)="clearState()"></p-dropdown>
                         
                        </div>

                    </div>
                    <div class="fliter-div">

                        <div class="col-md-12">
                            <h6>Select City</h6>
                        </div>


                        <div class="sellers d-flex">
                           
                            <p-dropdown inputId="city" [options]="cityList" [filter]="true" [showClear]="true"
                                placeholder="Select City" optionLabel="name" (onChange)="onCitySelect($event)"
                                (onClear)="clearCity()"></p-dropdown>
                         
                        </div>
                    </div>
                    <div class="fliter-div">

                        <div class="col-md-12">
                            <h6>Court</h6>
                        </div>
                        <div class="aminites available-section ">
                            <ul>
                                <li>
                                    <span> <p-checkbox binary="true" (onChange)="setHard($event)"></p-checkbox> </span>
                                    Hard/ Synthetic
                                </li>
                                <li>
                                    <span><p-checkbox binary="true" (onChange)="setGrass($event)"></p-checkbox> </span>
                                    Grass
                                </li>
                                <li>
                                    <span><p-checkbox binary="true" (onChange)="setClay($event)"></p-checkbox> </span>
                                    Clay
                                </li>
                            </ul>
                        </div>
                    </div> -->
                </div>
            </div>
            <!-- <div class="col-md-3  left-side-bar-filter">
                <div class="left-side-section">
                    <div class="">
                        <div class="col-md-12 main-title">
                            <h4>
                                <span>
                                    <i class='bx bx-filter-alt'></i>
                                </span> Filters
                            </h4>
                        </div>
                        <div class="price-range fliter-div pt-2">
                            <div class="col-md-12  p-p-0 filter-lable-title ">
                                <h6>Entry Fees </h6>
                                <button pButton label="Clear Filter" title="Clear Filter" class="p-button p-ml-2 p-mb-2"
                                    (click)=" clear('price') "></button>
                            </div>
                            <form [formGroup]="pricerangeform">

                                <div class="price-rangefeild d-flex">
                                    <ul>
                                        <li>
                                            <span class="currency">₹</span>
                                            <input type="number" class="form-control" placeholder="Min Price"
                                                formControlName="minvalue"
                                                [ngClass]="{ 'is-invalid': entryFeeSubmitted && entryFeeC.minvalue.errors?.invalidRange }">
                                          
                                        <li class="range-divider">-</li>
                                        <li class="smallrange-divider">
                                            <span>To</span>
                                        </li>
                                        <li>
                                            <span class="currency">₹</span>
                                            <input type="number" class="form-control" placeholder="Max Price"
                                                formControlName="maxvalue"
                                                [ngClass]="{ 'is-invalid': entryFeeSubmitted && entryFeeC.maxvalue.errors?.invalidRange }">
                                          
                                        </li>
                                        <li
                                            [pTooltip]="(entryFeeC.minvalue.errors && !entryFeeC.minvalue.errors?.invalidRange) ? 'Enter min and max value' : ''">

                                            <button
                                                [disabled]="(entryFeeC.minvalue.errors && !entryFeeC.minvalue.errors?.invalidRange)"
                                                (click)="onClickpricerange()">Go</button>
                                        </li>
                                    </ul>
                                    <div
                                        *ngIf="entryFeeSubmitted && entryFeeC.minvalue.errors?.invalidRange && entryFeeC.maxvalue.errors?.invalidRange">
                                        Min value cannot be greater than Max value
                                    </div>

                                </div>
                            </form>

                        </div>
                        <div class="price-range fliter-div pt-2">
                            <div class="col-md-12  p-p-0 filter-lable-title ">
                                <h6>Prize Pool</h6>
                                <button pButton label="Clear Filter" title="Clear Filter" class="p-button p-ml-2 p-mb-2"
                                    (click)=" clear('poolPrice') "></button>
                            </div>
                            <div class="price-rangefeild coins d-flex">
                                <p-dropdown [options]="cashORcoin" [disabled]="under18" [showClear]="true" [(ngModel)]="cashOrCoinSelection"
                                (onChange)="onClickCashCoin($event)" optionLabel="name" [autoDisplayFirst]="false" placeholder="Select Prize Pool"></p-dropdown>
                                <form [formGroup]="poolPricerangeform">
                                    <ul *ngIf="poolCash" class="mt-3">
                                        <li>

                                            <input type="number" class="form-control" placeholder="Min Cash"
                                                formControlName="minvalue"
                                                [ngClass]="{ 'is-invalid': poolCashPriceSubmitted && poolPrice.minvalue.errors }">
                                         
                                        </li>
                                        <li class="range-divider">-</li>
                                        <li class="smallrange-divider">
                                            <span>To</span>
                                        </li>
                                        <li>

                                            <input type="number" class="form-control" placeholder="Max Cash"
                                                formControlName="maxvalue"
                                                [ngClass]="{ 'is-invalid': poolCashPriceSubmitted && poolPrice.maxvalue.errors }">
                                           
                                        </li>
                                        <li
                                            [pTooltip]="(poolPrice.minvalue.errors && !poolPrice.minvalue.errors?.invalidRange) ? 'Enter min and max value' : ''">
                                            <button
                                                [disabled]="(poolPrice.minvalue.errors && !poolPrice.minvalue.errors?.invalidRange)"
                                                (click)="onClickPoolCash()">Go</button>
                                        </li>

                                    </ul>

                                    <ul *ngIf="!poolCash" class="mt-3">
                                        <li>

                                            <input type="number" class="form-control" placeholder="Min Coins"
                                                formControlName="minvalue"
                                                [ngClass]="{ 'is-invalid': poolCoinPriceSubmitted && poolPrice.minvalue.errors }">
                                            
                                        </li>
                                        <li class="range-divider">-</li>
                                        <li class="smallrange-divider">
                                            <span>To</span>
                                        </li>
                                        <li>

                                            <input type="number" class="form-control" placeholder="Max Coins"
                                                formControlName="maxvalue"
                                                [ngClass]="{ 'is-invalid': poolCoinPriceSubmitted && poolPrice.maxvalue.errors }">
                                            
                                        </li>
                                        <li
                                            [pTooltip]="(poolPrice.minvalue.errors && !poolPrice.minvalue.errors?.invalidRange) ? 'Enter min and max value' : ''">
                                            <button
                                                [disabled]="(poolPrice.minvalue.errors && !poolPrice.minvalue.errors?.invalidRange)"
                                                (click)="onClickPoolCoin()">Go</button>
                                        </li>
                                    </ul>
                                    <div
                                        *ngIf="poolCoinPriceSubmitted||poolCashPriceSubmitted && poolPrice.minvalue.errors?.invalidRange && poolPrice.maxvalue.errors?.invalidRange">
                                        Min value cannot be greater than Max value
                                    </div>
                                </form>
                                </div>
                        </div>
                    </div>
                    <div class="fliter-div ">
                        <div class="col-md-12 p-p-0">
                            <h6>Sorting </h6>
                        </div>
                        <div class="Category d-flex mb-3">
                            <div class="short-by right-bar w-100">
                                <div class="default-shorting  w-100">

                                    <p-dropdown [options]="shorting" [showClear]="true"
                                        placeholder="Select Sort By Price" (onChange)="onClickSort($event)"
                                        optionLabel="name"></p-dropdown>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="fliter-div " *ngIf="!under18">
                        <div class="col-md-12  p-p-0">
                            <h6>Type </h6>
                        </div>
                        <div class="Category d-flex mb-3">
                            <div class="short-by right-bar w-100">
                                <div class="default-shorting  w-100">
                                    <p-dropdown [options]="filterType" [showClear]="true" [(ngModel)]="type"
                                        (onChange)="onClickFreeOrPaid($event)" optionLabel="name"></p-dropdown>
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="fliter-div ">
                        <div class="col-md-12  p-p-0">
                            <h6>Contest Status </h6>
                        </div>
                        <div class="Category d-flex mb-3">
                            <div class="short-by right-bar w-100">
                                <div class="default-shorting  w-100">
                                    <p-dropdown [options]="contestMatchStatusArray" [showClear]="true"
                                        [autoDisplayFirst]="false" placeholder="Select contest status"
                                        optionLabel="label" appendTo="body" autoZIndex="true" baseZIndex="999999999 "
                                        (onChange)="onChangeContestStatus($event)"></p-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div> -->
            <div class="col-md-9 main-body">
                  <div class="col-md-12 right-section-top-bar">

                        <div class="searchTournament">
                            <div class="searchBar">
                                <input type="text" placeholder="Search Contest"   />
                                <img src="../../../assets/images/tournament/search.svg" alt="" class="icon">
                            </div>
                            <div class="shortBtn">
                                <button>
                                    <div class="icon">
                                        <img src="../../../assets/images/tournament/sort.svg" alt="">
                                    </div>
                                    <div class="title">
                                        Sort
                                    </div>
                                </button>
                            </div>
                            <div class="shortBtn ruleBtn">
                                <button (click)="showRulelist()">
                                    <div class="icon">
                                        <img src="../../../assets/img/contests/rule-icon.svg" alt="">
                                    </div>
                                    <div class="title">
                                        Rules
                                    </div>
                                </button>
                            </div>
                            <div class="shortBtn mobileFilters">
                                <button  >
                                    <div class="icon">
                                        <img src="../../../assets/images/tournament/Filter.svg" alt="">
                                    </div>
                                    <div class="title">
                                        FILTER
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>

               
                <div class="contest-page-list col-md-12 px-4">
                    <!-- <div class="row"> -->
                    <!---Contest Main List Start--->
                    <div *ngFor="let contest of contestList" class="col-md-12 contest-main-list">
                        <div class="joincontestlist p-0">
                            <div class="match-tournament contest ds-truncate1 w-100">
                                <div class="col-md-8 categoryname">
                                    <h5 class="prize-pool-heading left-heading">
                                        {{contest.displaytournamentName}}
                                    </h5>
                                </div>
                                <div class="col-md-4 prizepool">
                                    <h5 class="prize-pool-heading right-heading">
                                        {{contest.tournamentCategoryName}}
                                    </h5>
                                </div>
                            </div>
                            <div class="col-md-12 list col-sm-12">
                                <div class=" give-subtitle pt-0" *ngIf="contest?.giveAway">
                                    <h6 class="blinking-text"> <span>{{ contest?.giveAway }}</span> </h6>
                                </div>
                                <div class="palyers-details">
                                    <div class="player palyer1">
                                        <div class="team-1">
                                            <img src="{{contest.player1Image}}" alt="" class="single-div">
                                            <div class="user-image double-contest-div d-none">
                                                <p-avatarGroup styleClass="mb-1 ">
                                                    <p-avatar image="{{contest.player1Image}}" size="large"
                                                        shape="circle"></p-avatar>
                                                    <!-- <p-avatar image="assets/img/players/user-image-male.png"
                                                                    size="large" shape="circle"></p-avatar> -->
                                                </p-avatarGroup>
                                            </div>
                                            <div class="name">
                                                <h6 class="title" [innerHTML]="contestPlayerName(contest.player1Name)">

                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vs-tag">
                                        <img  src="../../../assets/img/contests/vs.svg" alt="">

                                        <div class="share-buttons-btn desktop-version"
                                        [ngClass]="contest.tournamentMatchStatus === 'finished' ? 'closeShareBtn' : ''">
                                        <a href="{{contest.shareurl}}" target="_blank">
                                            <button class="share-button-click"> Share <span><img src="../../../assets/img/contests/whatsapp.png" alt=""></span></button>
                                        </a>
                                    </div>
                                    </div>
                                    <div class="player palyer2">
                                        <div class="team-2">
                                            <img src="{{contest.player2Image}}" alt="" class="single-div">
                                            <!--Below Code is testing for double image please remove this code when it's come dynamic value --->
                                            <div class="user-image double-contest-div d-none">
                                                <p-avatarGroup styleClass="mb-1 ">
                                                    <p-avatar image="{{contest.player2Image}}" size="large"
                                                        shape="circle"></p-avatar>
                                                    <!-- <p-avatar image="assets/img/players/user-image-male.png"
                                                                    size="large" shape="circle"></p-avatar> -->
                                                </p-avatarGroup>
                                            </div>
                                            <div class="name">
                                                <h6 class="title" [innerHTML]="contestPlayerName(contest.player2Name)">

                                                </h6>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="match-date-time">
                                    <!-- <p style="font-size: 14px;text-align: center;font-weight: 700;"
                                                class="date-time-location">
                                                {{contest.tournamentName}}</p> -->
                                    <h5 class="date" >
                                        <span class="icon">
                                            <img src="../../../assets/img/contests/date.svg" alt="">
                                        </span>
                                        {{contest.matchDate|date:'MMMM d, y, h:mm a'}}
                                    </h5>
                                    <h5>
                                        <span class="icon" *ngIf="contest['displayTime']">
                                            <img src="../../../assets/img/contests/clock.svg" alt="">
                                        </span>
                                        <span class="time-bold-text"> {{contest['displayTime']}}</span>
                                        <span class="time-bold-text"
                                            *ngIf="contest['displayTime'] === 'Match Started' && contest['matchDateTimeUpdated']">
                                            Match Delayed
                                        </span>
                                    </h5>

                                    <!-- <button href="{{shareurl}}" class="contest-btn">Share WhatsApp</button> -->
                                </div>

                                <div class="contest-buttons">
                                    <div class="pricePool">
                                        <div class="subtitle">
                                            <h6>Prize Pool </h6>
                                        </div>
                                        <div class="action-btn">
                                            <button *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0"> 
                                                <span class="price-pool-number">
                                                    {{contest.updatedPoolCoins}}
                                                </span>
                                                <span class="tpl-cash-coins"> TPL Coins</span> 
                                            </button>
                                            <button  *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0"> 
                                                <span class="price-pool-number">
                                                    <i class='bx bx-rupee'></i>{{contest.updatedPoolCash}}
                                                </span>
                                            </button>  
                                        </div>
                                    </div>
                                    <div class="pricePool">
                                        <div class="subtitle">
                                            <h6>Entry Fee - 
                                                <span class="fees-number-01" *ngIf="contest.entryFee > 0 && contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0"> {{contest.entryFee}}</span>
                                                <span class="fees-number-01" *ngIf="contest.entryFee == 0"> Free</span>   
                                                <span class="priceType"  *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">
                                                    <span class="entry_fees1"> TPL Coins</span>
                                                </span>
                                                <span class="priceType" *ngIf="contest.entryFee > 0 && contest.updatedPoolCash !== null && contest.updatedPoolCash > 0">
                                                    <span class="entry_fees1"> <i class='bx bx-rupee'></i>{{contest.entryFee}}</span>
                                                </span>
                                            </h6>
                                        </div>
                                        <div class="joint-button">
                                            <button *ngIf="contest['displayTime'] !== 'Match Started' && contest.tournamentMatchStatus === 'notstarted' && contest.isContestRegistrationComplete == undefined"
                                                (click)="onClickJoin(contest)" [disabled]="isAcademy"
                                                class="contest-btn-main"
                                                [ngClass]="isAcademy ? 'disableAcademyJoin' : ''"> Join Now   
                                            </button>
                                            <button
                                                *ngIf="contest['displayTime'] !== 'Match Started' && contest.tournamentMatchStatus === 'notstarted' && contest.isContestRegistrationComplete == true"
                                                (click)="onClickLive(contest)" class="contest-btn-main"> Leaderboard
                                                
                                            </button>
                                            <button
                                                *ngIf="contest['displayTime'] !== 'Match Started' && contest.tournamentMatchStatus === 'notstarted' && contest.isContestRegistrationComplete == false"
                                                (click)="onClickRejoin(contest)" class="contest-btn-main">
                                                Resume 
                                            </button>
                                            <button
                                                *ngIf="contest.tournamentMatchStatus === 'inprogress' && contest.isContestRegistrationComplete == true"
                                                (click)="onClickLive(contest)" class="contest-btn-main"> Live <i
                                                    class='bx bx-right-arrow-alt'></i>
                                            </button>
                                            <button
                                                *ngIf="contest.tournamentMatchStatus === 'inprogress' && contest.isContestRegistrationComplete == false"
                                                class="contest-btn-main"> Live 
                                            </button>
                                            <button
                                                *ngIf="contest.tournamentMatchStatus === 'inprogress' && contest.isContestRegistrationComplete == undefined"
                                                class="contest-btn-main"> Live 
                                            </button>
                                            <button
                                                *ngIf="contest.tournamentMatchStatus === 'finished' && contest.isContestRegistrationComplete == true"
                                                (click)="onClickLive(contest)" class="contest-btn-main"> Close 
                                            </button>
                                            <button
                                                *ngIf="contest.tournamentMatchStatus === 'finished' && contest.isContestRegistrationComplete == undefined"
                                                class="contest-btn-main"> Close
                                            </button>

                                            <button
                                                *ngIf="contest.tournamentMatchStatus === 'suspended' || contest.tournamentMatchStatus === 'interrupted' || contest.tournamentMatchStatus === 'canceled'"
                                                class="contest-btn-main"> Match Suspended
                                            </button>
                                        </div>  
                                    </div>
                                </div> 
                                <div class="hr-bottom mobile">
                                    <div class="Entries"> 
                                        <h5 class="number-of-entries">Number Of Entries - {{contest.totalEntries}}</h5>
                                    </div>
                                    <div class="Winnings">
                                        <span class="winnings-button winnings-button-mobile my-2" (click)="showPrizePoolNewstructure(contest)" style="cursor: pointer;">
                                            Winnings
                                        </span>
                                    </div>
                                  
                                </div>
                                <div class="hr-bottom web">
                                    <div class="Entries">
                                        <h5 class="number-of-entries">Number Of Entries - {{contest.totalEntries}}</h5>
                                    </div>
                                    <div class="Winnings">
                                        <span class="winnings-button winnings-button-web my-2" (click)="showPrizePoolNewstructure(contest)" style="cursor: pointer;">
                                            Winnings
                                        </span>
                                    </div>
                                    
                                </div>
                            </div>

                        </div>


<div class="divider-main">
    <img src="../../../assets/img/contests/Line10.png" alt="">
</div>
                    </div>





                    <!---Contest Main List End--->
                    <div *ngIf="isContestAvailable">
                        <div class="not-found-section">
                            <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif" alt="">
                                <h4>No Contest Available!</h4>
                                <p>Please check back later for updates or explore other ongoing contest.</p>
                            </div>
                        </div>

                    </div>
                    <div class="contest-pagination">
                        <div class="p-d-flex p-ai-center p-jc-between">
                            In total there are
                            {{totalContestRecords }} Contests.
                        </div>
                        <div class="pagination-div">
                            <p-paginator *ngIf="contestList.length > 0" [rows]="pageLimitFirst" #paginator pageLinkSize="3" [showPageLinks]="true"
                                [totalRecords]="totalContestRecords" (onPageChange)="loadContest($event, mode)" [first]="(pageNumberFirst - 1) * pageLimitFirst"
                                [rowsPerPageOptions]=" pagination"></p-paginator>
                        </div>
                    </div>



                </div>
                <!-- </div> -->
            </div>
        </div>
    </div>

</section>





<p-dialog header="Contest Prize Pool Structure " [(visible)]="pricePoolStructurePopup" [modal]="true"
    class="prize-pool-structure" [style]="{ width: '30%' }" [draggable]="false" [resizable]="false"
    id="poolStructurePopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 60px)' }">
    <div class="col-md-12 p-p-0">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col" class="entries-position">Position</th>
                    <th scope="col" class="entries-position" *ngIf="twoToFour">2 to 4 Entries</th>
                    <th scope="col" class="entries-position" *ngIf="fiveToSeven"> 5 to 7 Entries</th>
                    <th scope="col" class="entries-position" *ngIf="eightToTen">8 to 10 Entries</th>
                    <th scope="col" class="entries-position" *ngIf="elevenToThirteen">11 to 13 Entries</th>
                    <th scope="col" class="entries-position" *ngIf="fourteenToEighteen">14 to 18 Entries</th>
                    <th scope="col" class="entries-position" *ngIf="nineteenToTwentySeven">19 to 27 Entries</th>
                    <th scope="col" class="entries-position" *ngIf="twentyEightToThirtySix">28 to 36 Entries</th>
                    <th scope="col" class="entries-position" *ngIf="thirtySevenToFifty">37 to 50 Entries</th>
                    <th scope="col" class="entries-position" *ngIf="fiftyOnePlus">51+ Entries</th>
                </tr>
            </thead>
            <tbody> 
                <tr
                    *ngIf="twoToFour || fiveToSeven || eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">1st</th>
                    <td class="table-data" *ngIf="twoToFour">100%</td>
                    <td class="table-data" *ngIf="fiveToSeven">65%</td>
                    <td class="table-data" *ngIf="eightToTen">50%</td>
                    <td class="table-data" *ngIf="elevenToThirteen">40%</td>
                    <td class="table-data" *ngIf="fourteenToEighteen">40%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">33%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">29%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">28%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">27%</td>
                </tr>
                <tr
                    *ngIf="fiveToSeven || eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">2nd</th>
                    <td class="table-data" *ngIf="fiveToSeven">35%</td>
                    <td class="table-data" *ngIf="eightToTen">30%</td>
                    <td class="table-data" *ngIf="elevenToThirteen">30%</td>
                    <td class="table-data" *ngIf="fourteenToEighteen">23%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">20%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">18%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">16%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">15%</td>
                </tr>
                <tr
                    *ngIf="eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">3rd</th>
                    <td class="table-data" *ngIf="eightToTen">20%</td>
                    <td class="table-data" *ngIf="elevenToThirteen">20%</td>
                    <td class="table-data" *ngIf="fourteenToEighteen">16%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">15%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">14%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">13%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">13%</td>
                </tr>
                <tr
                    *ngIf="elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">4th</th>
                    <td class="table-data" *ngIf="elevenToThirteen">10%</td>
                    <td class="table-data" *ngIf="fourteenToEighteen">12%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">11%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">11%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">10%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">10%</td>
                </tr>
                <tr
                    *ngIf="fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">5th</th>
                    <td class="table-data" *ngIf="fourteenToEighteen">9%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">8%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">9%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">9%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">9%</td>
                </tr>
                <tr *ngIf="nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">6th</th>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">7%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">8%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">8%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">8%</td>

                </tr>
                <tr *ngIf="nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">7th</th>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">6%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">6%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">7%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">7%</td>
                </tr>
                <tr *ngIf="twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">8th</th>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">5%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">5%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">5%</td>
                </tr>
                <tr *ngIf="thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">9th</th>
                    <td class="table-data" *ngIf="thirtySevenToFifty">4%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">4%</td>
                </tr>
                <tr *ngIf="fiftyOnePlus">
                    <th scope="row" class="entries-position">10th</th>
                    <td class="table-data" *ngIf="fiftyOnePlus">2%</td>
                </tr>
            </tbody>
        </table>
    </div>
</p-dialog>

<!-- <p-dialog header="Contest Prize Pool Structure " [(visible)]="pricePoolStructurePopup" [modal]="true"
    class="prize-pool-structure" [style]="{ width: '30%' }" [draggable]="false" [resizable]="false"
    id="poolStructurePopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }">
    <div class="col-md-12 p-p-0">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col" class="entries-position">Position</th>
                    <th scope="col" class="entries-position" *ngIf="twoToFour">2 to 4 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="fiveToSeven"> 5 to 7 <br class="mobile-version-br">
                        Entries</th>
                    <th scope="col" class="entries-position" *ngIf="sevenToTen">7 to 10 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="eightToTwelve">8 to 12 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="thirteenToEighteen">13 to 18 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="nineteenToTwentySeven">19 to 27 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="twentyEightToThirtySix">28 to 36 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="thirtySevenToFifty">37 to 50 <br
                            class="mobile-version-br">Entries</th>
                    <th scope="col" class="entries-position" *ngIf="fiftyOnePlus">51+ <br
                            class="mobile-version-br">Entries</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngIf="twoToFour || fiveToSeven || sevenToTen || eightToTwelve || thirteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">1st</th>
                    <td class="table-data" *ngIf="twoToFour">100%</td>
                    <td class="table-data" *ngIf="fiveToSeven">65%</td>
                    <td class="table-data" *ngIf="sevenToTen">50%</td>
                    <td class="table-data" *ngIf="eightToTwelve">50%</td>
                    <td class="table-data" *ngIf="thirteenToEighteen">40%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">40%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">33%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">29%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">27%</td>
                </tr>
                <tr
                    *ngIf="fiveToSeven || sevenToTen || eightToTwelve || thirteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">2nd</th>
                    <td class="table-data" *ngIf="fiveToSeven">35%</td>
                    <td class="table-data" *ngIf="sevenToTen">30%</td>
                    <td class="table-data" *ngIf="eightToTwelve">30%</td>
                    <td class="table-data" *ngIf="thirteenToEighteen">30%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">23%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">20%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">18%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">15%</td>
                </tr>
                <tr
                    *ngIf="sevenToTen || eightToTwelve || thirteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">3rd</th>
                    <td class="table-data" *ngIf="sevenToTen">20%</td>
                    <td class="table-data" *ngIf="eightToTwelve">20%</td>
                    <td class="table-data" *ngIf="thirteenToEighteen">20%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">16%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">15%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">13%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">13%</td>
                </tr>
                <tr
                    *ngIf="thirteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">4th</th>
                    <td class="table-data" *ngIf="thirteenToEighteen">10%</td>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">12%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">10%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">10%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">10%</td>
                </tr>
                <tr
                    *ngIf="nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">5th</th>
                    <td class="table-data" *ngIf="nineteenToTwentySeven">9%</td>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">8%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">8%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">9%</td>
                </tr>
                <tr *ngIf="twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">6th</th>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">7%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">7%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">7%</td>

                </tr>
                <tr *ngIf="twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">7th</th>
                    <td class="table-data" *ngIf="twentyEightToThirtySix">6%</td>
                    <td class="table-data" *ngIf="thirtySevenToFifty">6%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">7%</td>
                </tr>
                <tr *ngIf="thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">8th</th>
                    <td class="table-data" *ngIf="thirtySevenToFifty">5%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">5%</td>
                </tr>
                <tr *ngIf="thirtySevenToFifty || fiftyOnePlus">
                    <th scope="row" class="entries-position">9th</th>
                    <td class="table-data" *ngIf="thirtySevenToFifty">4%</td>
                    <td class="table-data" *ngIf="fiftyOnePlus">4%</td>
                </tr>
                <tr *ngIf="fiftyOnePlus">
                    <th scope="row" class="entries-position">10th</th>
                    <td class="table-data" *ngIf="fiftyOnePlus">2%</td>
                </tr>
            </tbody>
        </table>
    </div>
</p-dialog> -->

<!-- <p-dialog id="login" [(visible)]="loginRegisterModal" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }"
    [style]="{ width: '43.3rem' }" [modal]="true" [draggable]="false" [resizable]="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
        max-width: 100%;">
        <div class="modal-content" style="border: none;">
            <div class="modal-body">
                <section class="login-page-section">
                    <div class="model-image">
                        <img src="../../../../assets/img/login/popup.png" alt="">
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12 ">
                                <div class="col-md-12 login-page">
                                    <form class="login-form" [formGroup]="loginForm" *ngIf="this.loginForm"
                                        (ngSubmit)="onSubmit()">
                                        <p-tabView id="myTabContent">
                                            <p-tabPanel header="Login with OTP" [disabled]="false">
                                                <div class="container  ">
                                                    <div class="row">
                                                        <div class="col-md-12  p-p-0">
                                                            <div *ngIf="!showMobileLoginOtpForm"
                                                                class="col-md-12 login-page OTP">
                                                                <form class="login-form" [formGroup]="mobileLoginForm"
                                                                    *ngIf="this.mobileLoginForm"
                                                                    (ngSubmit)="onMobilePhoneSubmit()">
                                                                    <div class="Phone form-lable">
                                                                        <label for="name_login">Enter your mobile no. <span
                                                                                class="mandatory-fields">*</span></label>
                                                                        <div class="clear"></div>
                                                                        <p-inputNumber mode="decimal"
                                                                            [useGrouping]="false"
                                                                            formControlName="mobileNumber"
                                                                            [maxlength]="10"
                                                                            [ngClass]="{ 'is-invalid': submitted && mobNumberFormValidation.mobileNumber.errors }"
                                                                            required
                                                                            placeholder="00000 00000">
                                                                        </p-inputNumber>
                                                                        <div *ngIf="submitted && mobNumberFormValidation.mobileNumber.errors"
                                                                            class="invalid-feedback">
                                                                            <div
                                                                                *ngIf="mobNumberFormValidation.mobileNumber.errors.required">
                                                                                Mobile number is required.
                                                                            </div>
                                                                            <div
                                                                                *ngIf="!mobNumberFormValidation.mobileNumber.errors.required && mobNumberFormValidation.mobileNumber.errors">
                                                                                Please enter a valid 10 digit mobile
                                                                                number.
                                                                            </div>
                                                                        </div>
                                                                  <div class="invalidmobile" *ngIf="showMobileFormErrors" style="font-size: 14px;">
                                                                            {{mobileFormsErrors}}
                                                                        </div>
                                                                    </div>

                                                                    <div id="login-submit">
                                                                        <input type="submit"
                                                                            value="SEND OTP">
                                                                    </div>
                                                                </form>
                                                            </div>
                                                            <div *ngIf="showMobileLoginOtpForm"
                                                                class="col-md-12 Otp login-page main-otp-screen">
                                                                <div
                                                                    class="container height-100 d-flex justify-content-center align-items-center">
                                                                    <div class="position-relative">
                                                                        <div class="card p-2 text-center">
                                                                            <div class="col-md-12 otp-header">
                                                                                <div class="row">
                                                                                    <div class="col-2">
                                                                                        <div class="back-btn-otp"
                                                                                            (click)="onClickOtpback()">
                                                                                            <i
                                                                                                class="bi bi-chevron-left"></i>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-10">
                                                                                        <h2>VERIFY DETAILS</h2>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div> <span>OTP sent to </span>
                                                                                <small>{{mobileNumber}}</small>
                                                                            </div>
                                                                            <div id="otp"
                                                                                class="inputs d-flex flex-row justify-content-center mt-2 mb-2">
                                                                                <ng-otp-input #ngOtpInput
                                                                                    (onInputChange)="onOtpChange($event)"
                                                                                    [config]="config"
                                                                                    autoFocusOnLoad={false}>
                                                                                </ng-otp-input>
                                                                                <div style="display: block;">
                                                                                    <div *ngIf="showOtpErrors">
                                                                                        <span style="color: red!important;">Please
                                                                                            enter valid OTP.</span>
                                                                                    </div>
                                                                                    <div *ngIf="showOtpLoginErrors">
                                                                                        <span
                                                                                            style="color: red!important;">{{otpLoginErrors}}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <span
                                                                                    *ngIf="!showResendButton">{{displayTime}}
                                                                                    {{transform(counter)}}</span>
                                                                                <span *ngIf="showResendButton">
                                                                                    <div id="">
                                                                                        <a (click)="resendOtp()"
                                                                                            style="text-decoration: underline;cursor: pointer;">Resend</a>
                                                                                    </div>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div id="login-submit">
                                                                    <input type="submit"
                                                                        (click)="onClickOtpLoginSubmit()"
                                                                        value="VERIFY & PROCEED">
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </p-tabPanel>

                                        </p-tabView>
                                    </form>
                                    <div class="ragister-btn new-ragistration"> New User? <a
                                            routerLink="/login-register">Register Now.</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</p-dialog> -->


<p-dialog [closable]="true" [(visible)]="showForgotPasswordForm" [modal]="true" [style]="{width: '500px'}"
    id="forgot-password" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false">
    <section *ngIf="showForgotPasswordForm" class="login-page-section">
        <div class="section-title text-center">
            <p> Forgot Password
            </p>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-12 ">
                    <div class="col-md-12 login-page">
                        <form [formGroup]="forgotPassForm">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="style-form-group">
                                        <input type="email" formControlName="email" class="form-control form-input"
                                            placeholder="Your Email *"
                                            [ngClass]="{ 'is-invalid': submitted && forgotPassValidation.email.errors }">
                                        <div *ngIf="submitted && forgotPassValidation.email.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="forgotPassValidation.email.errors.required">Email is
                                                required</div>
                                            <div *ngIf="forgotPassValidation.email.errors.pattern">Email must be a
                                                valid
                                                email address</div>
                                        </div>
                                        <div *ngIf="successMessage" style="color:green;">{{successMessage.message}}
                                        </div>
                                        <div *ngIf="errorMessage" style="color:red;">{{errorMessage}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="button pt-2 pt-lg-3">
                                <button class="forgot-pass-submit"
                                    (click)="onForgotPassSubmit()">Submit</button>&nbsp;&nbsp;
                                <button class="forgot-pass-back" (click)="onForgotPassBack()">Back</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</p-dialog>
<!-- 
<p-dialog [closable]="true" [(visible)]="showForgotPasswordForm" [modal]="true" [style]="{width: '38vw'}"
    [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <section *ngIf="showForgotPasswordForm" class="login-page-section">
        <div class="section-title text-center">
            <p> Forgot Password
            </p>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-12 ">
                    <div class="col-md-12 login-page">
                        <form [formGroup]="forgotPassForm">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="style-form-group">
                                        <input type="email" formControlName="email" class="form-control form-input"
                                            placeholder="Your Email *"
                                            [ngClass]="{ 'is-invalid': submitted && forgotPassValidation.email.errors }">
                                        <div *ngIf="submitted && forgotPassValidation.email.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="forgotPassValidation.email.errors.required">Email is
                                                required</div>
                                            <div *ngIf="forgotPassValidation.email.errors.pattern">Email must be a
                                                valid
                                                email address</div>
                                        </div>
                                        <div *ngIf="successMessage" style="color:green;">{{successMessage.message}}
                                        </div>
                                        <div *ngIf="errorMessage" style="color:red;">{{errorMessage}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="button pt-2 pt-lg-3">
                                <button class="forgot-pass-submit"
                                    (click)="onForgotPassSubmit()">Submit</button>&nbsp;&nbsp;
                                <button class="forgot-pass-back" (click)="onForgotPassBack()">Back</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</p-dialog> -->

<p-dialog id="add-cash" header="Add Contest Cash" [(visible)]="showAddCashModal"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '500px' }" [modal]="true"
    [draggable]="false" [resizable]="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
        <div class="modal-content">

            <div class="modal-body add-cash pay">
                <div class="card-body">
                    <div class="payment-info flex justify-space-between">
                        <div class="column shipping w-100">
                            <form [formGroup]="addCashForm" *ngIf="this.addCashForm" (ngSubmit)="onCashSubmit()">
                                <div class="container-fluid grid">
                                    <div class="row pull-center">
                                        <div class="col-md-12 ">
                                            <div class="wallet-screen" style="display: block;">
                                                <div class="total-amount">
                                                    <div class="wallet-icons">
                                                        <div class="icon">
                                                            <i class='bx bx-wallet-alt'></i>
                                                        </div>
                                                        <h1>Enter Amount</h1>
                                                    </div>
                                                    <div class="col-md-12 add-buttons">
                                                        <div class="add-money-form col-md-12">
                                                            <p-inputNumber mode="decimal" id="myInput2"
                                                                [useGrouping]="false" formControlName="cash"
                                                                [ngClass]="{ 'is-invalid': cashFormSubmitted && cashFormValidation.cash.errors }"
                                                                required placeholder="₹ 0">
                                                            </p-inputNumber>


                                                            <div *ngIf="cashFormSubmitted && cashFormValidation.cash.errors"
                                                                class="invalid-feedback">
                                                                <div *ngIf="cashFormValidation.cash.errors.required">
                                                                    Please enter cash value
                                                                </div>
                                                            </div>
                                                            <div *ngIf="showCashError">
                                                                <span>Please add 100 Rs Or grater than 100 Rs.</span>
                                                            </div>
                                                            <div class="p-field p-col-12 msg-div">
                                                                <p-messages severity="info">
                                                                    <ng-template pTemplate>
                                                                        <i class="pi pi-info-circle"></i>
                                                                        <div class="ml-2">Please Note: For iPhone users
                                                                            - To make a payment using Gpay, select
                                                                            "Others" option in the UPI menu and manually
                                                                            enter your UPI ID.
                                                                        </div>
                                                                    </ng-template>
                                                                </p-messages>

                                                            </div>
                                                        </div>
                                                        <!-- <div class="p-field p-col-12 msg-div">
                                                            <p-messages severity="info">
                                                                <ng-template pTemplate>
                                                                    <i class="pi pi-info-circle"></i>
                                                                    <div class="ml-2">Please Note: For iPhone users - To
                                                                        make a payment using Gpay, select "Others"
                                                                        option in the UPI menu and manually enter your
                                                                        UPI ID.</div>
                                                                </ng-template>
                                                            </p-messages>

                                                        </div> -->
                                                        <div id="text-out">{{outputText}}</div>
                                                        <div class="col-md-12 text-center">
                                                            <button class="button button-primary" pButton
                                                                type="submit">Add to Wallet</button>


                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-dialog>


<p-dialog id="add-cash" header="TPL Cash Convert To Money" [(visible)]="showAddMoneyModal"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '500px' }" [modal]="true"
    [draggable]="false" [resizable]="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
        <div class="modal-content">

            <div class="modal-body add-cash pay">
                <div class="card-body">
                    <div class="payment-info flex justify-space-between">
                        <div class="column shipping w-100">
                            <form [formGroup]="addCashForm" *ngIf="this.addCashForm" (ngSubmit)="onCashSubmit()">
                                <div class="container-fluid grid">
                                    <div class="row pull-center">
                                        <div class="col-md-12 ">
                                            <div class="wallet-screen" style="display: block;">
                                                <div class="total-amount">
                                                    <!-- <div class="cashAvailableInTplMoney">
                                                </div> -->
                                                <div class="col-md-12 add-buttons">
                                                    <div class="heading d-flex justify-content-center cashAvailableInTplMoney">
                                                            <h3 style="font-size: 11px;">TPL Cash Available : <span style="font-size: 15px;">₹{{ tplCash }}</span></h3>
                                                        </div>
                                                    </div>
                                                    <div class="wallet-icons">
                                                        <div class="icon">
                                                            <i class='bx bx-wallet-alt'></i>
                                                        </div>
                                                        <h1>Enter Amount</h1>
                                                    </div>
                                                    <div class="col-md-12 add-buttons">
                                                        <div class="add-money-form col-md-12">
                                                            <p-inputNumber mode="decimal" id="myInput2"
                                                                [useGrouping]="false" formControlName="cash"
                                                                [ngClass]="{ 'is-invalid': cashFormSubmitted && cashFormValidation.cash.errors }"
                                                                required placeholder="₹ 0">
                                                            </p-inputNumber>


                                                            <div *ngIf="cashFormSubmitted && cashFormValidation.cash.errors"
                                                                class="invalid-feedback">
                                                                <div *ngIf="cashFormValidation.cash.errors.required">
                                                                    Please enter cash value
                                                                </div>
                                                            </div>
                                                            <div *ngIf="showCashError">
                                                                <span>Please add 100 Rs Or grater than 100 Rs.</span>
                                                            </div>
                                                            <div class="p-field p-col-12 msg-div">
                                                                <p-messages severity="info">
                                                                    <ng-template pTemplate>
                                                                        <i class="pi pi-info-circle"></i>
                                                                        <div class="ml-2">Please Note: 1 Money = 1 Rupees.
                                                                        </div>
                                                                    </ng-template>
                                                                </p-messages>

                                                            </div>
                                                        </div>
                                                        <!-- <div class="p-field p-col-12 msg-div">
                                                            <p-messages severity="info">
                                                                <ng-template pTemplate>
                                                                    <i class="pi pi-info-circle"></i>
                                                                    <div class="ml-2">Please Note: For iPhone users - To
                                                                        make a payment using Gpay, select "Others"
                                                                        option in the UPI menu and manually enter your
                                                                        UPI ID.</div>
                                                                </ng-template>
                                                            </p-messages>

                                                        </div> -->
                                                        <div id="text-out">{{outputText}}</div>
                                                        <div class="col-md-12 text-center">
                                                            <button class="button button-primary" pButton icon="pi pi-arrow-right-arrow-left" label="Convert"
                                                                type="submit"></button>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-dialog>


<!-- <p-dialog [closable]="true" [(visible)]="showAddCashModal" [modal]="true" [style]="{width: '38vw'}"
    [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <form class="" [formGroup]="addCashForm" *ngIf="this.addCashForm" (ngSubmit)="onCashSubmit()">
        Add Cash
        <div class="col-md-4">
            <p-inputNumber mode="decimal" [useGrouping]="false" formControlName="cash"
                [ngClass]="{ 'is-invalid': cashFormSubmitted && cashFormValidation.cash.errors }" required
                placeholder="Enter Multiple of 100">
            </p-inputNumber>
            <div *ngIf="cashFormSubmitted && cashFormValidation.cash.errors" class="invalid-feedback">
                <div *ngIf="cashFormValidation.cash.errors.required">Please enter cash value
                </div>
            </div>
            <div *ngIf="showCashError">
                <span>Please add 100 Rs Or grater than 100 Rs.</span>
            </div>

        </div>

        <div class="col-md-4">
            <button pButton type="submit">Submit</button>
        </div>

    </form>
</p-dialog> -->


    <p-dialog id="terms" [closable]="true" [(visible)]="showRuleList" [modal]="true" [style]="{width: '500px'}"
     header="Points System"
    [breakpoints]="{'960px': '60vw', '640px': 'calc(100% - 60px)'}" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false">
    <div class="modal-content team qize-section question-list quize-description">
        <div class="note-top">
            <p class="text">SELECT THE BEST COMBINATION TO MAXIMIZE YOUR POINTS</p>
        </div> 
        <div class="modal-body modal-Detals">
            <div class="col-md-12 quiz-main-body">
                <div class="qizeheader ">
                    <div class="mobile-version">
                        <!-- <a onclick="history.back()" class="left-title mobile">
                            <i class='bx bx-left-arrow-alt'></i> Back
                        </a> -->
                    </div>
                    <div class="left-title   w-auto"> </div>
                </div>
                <div class="content"> 
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-sm-12 p-p-0">
                                 <div class="point-list">
                                    <ul>
                                        <li>
                                            ⁠Choose 1 option from one player
                                        </li>
                                        <li>
                                            ⁠Choose 2 options for the other player
                                        </li>
                                    </ul>
                                    <div class="note2">
                                        <p class="text"> ⁠Total points will be calculated based on the 3 options selected</p>
                                    </div>
                                 </div>
                                 <div class="point-table">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th scope="col"  colspan="2">points system</th>
                                               
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th scope="row" class="entries-position">1 Point Won</th>
                                                <td class="table-data">1 point</td> 
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">1 Game Won</th>
                                                <td class="table-data">6 points</td> 
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">⁠1 Set Won</th>
                                                <td class="table-data">50 points</td> 
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">1 Service  Point won</th>
                                                <td class="table-data">1.5 points</td> 
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">⁠1 Ace</th>
                                                <td class="table-data">15 points</td> 
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">1 Break Point won</th>
                                                <td class="table-data">20 points</td> 
                                            </tr>
                                           
                                        </tbody>
                                    </table>

                                 </div>
                                
                                
                            </div> <!-- End of col-sm-12 -->
                        </div> <!-- End of row -->
                    </div> <!-- ENd of container fluid -->
                </div>
            </div>
        </div>
    </div>



</p-dialog>


<p-dialog id="terms" [closable]="true" [(visible)]="showContestDetailSection" [modal]="true" [style]="{width: '500px'}"
    (onHide)="onCloseShowContestDetailSection()" header="Points System"
    [breakpoints]="{'960px': '60vw', '640px': 'calc(100% - 60px)'}" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false">
    <div class="modal-content team qize-section question-list quize-description">
        <div class="note-top">
            <p class="text">SELECT THE BEST COMBINATION TO MAXIMIZE YOUR POINTS</p>
        </div>
        <div class="modal-body modal-Detals">
            <div class="col-md-12 quiz-main-body">
                <div class="qizeheader ">
                    <div class="mobile-version">
                        <!-- <a onclick="history.back()" class="left-title mobile">
                            <i class='bx bx-left-arrow-alt'></i> Back
                        </a> -->
                    </div>
                    <div class="left-title   w-auto"> </div>
                </div>
                <div class="content"> 
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-sm-12 p-p-0">
                                 <div class="point-list">
                                     <ul>
                                         <li>
                                            ⁠Choose 1 option from one player
                                        </li>
                                        <li>
                                            ⁠ ⁠Choose 2 options for the other player
                                        </li>
                                    </ul>
                                    <div class="note2">
                                        <p class="text"> ⁠Total points will be calculated based on the 3 options selected</p>
                                    </div>
                                 </div>
                                 <div class="point-table">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th scope="col"  colspan="2">points system</th>
                                               
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th scope="row" class="entries-position">1 Point Won</th>
                                                <td class="table-data">1 point</td> 
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">1 Game Won</th>
                                                <td class="table-data">6 points</td> 
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">⁠1 Set Won</th>
                                                <td class="table-data">50 points</td> 
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">1 Service  Point won</th>
                                                <td class="table-data">1.5 points</td> 
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">⁠1 Ace</th>
                                                <td class="table-data">15 points</td> 
                                            </tr>
                                            <tr>
                                                <th scope="row" class="entries-position">1 Break Point won</th>
                                                <td class="table-data">20 points</td> 
                                            </tr>
                                           
                                        </tbody>
                                    </table>

                                 </div>
                                
                                <div class="col-md-12  acept-div0main">
                                    <div class="form-check p-0 d-flex align-items-start mb-2"
                                        [ngClass]="showTermsAndConditionError ? 'Error-div' : ''">
                                        <p-checkbox binary="true" [(ngModel)]="isTermsAndConditionsSelected"
                                            (onChange)="onTermsAndConditionsSelect($event, contest)"></p-checkbox>
                                        <label class="form-check-label" for="defaultCheck1">
                                            I accept the <a href="/termsandcondition#TPLcontest">Terms and
                                                Conditions</a> as well as the <a (click)="showPoolstructure()">Prize
                                                Pool Structure .</a>
                                        </label>

                                    </div>
                                    <!-- <div class="form-check p-0 d-flex align-items-start" *ngIf="contest?.updatedPoolCoins !== null && contest?.updatedPoolCoins > 0">
                                        <p-checkbox binary="true" [(ngModel)]="isDontShowAgainSelected"
                                            (onChange)="onDontShowAgainSelect($event)"></p-checkbox>
                                        <label class="form-check-label" for="defaultCheck2">
                                            Don't Show Again
                                        </label>
                                    </div> -->
                                    <div class="error-msg" *ngIf="showTermsAndConditionError">
                                        <span>Please Accept Terms and Conditions.</span>
                                    </div>
                                </div>
                            </div> <!-- End of col-sm-12 -->
                        </div> <!-- End of row -->
                    </div> <!-- ENd of container fluid -->
                </div>
            </div>
        </div>
    </div>


    <ng-template pTemplate="footer">
        <div class="footer-buttons-section">
            <button class="btn btn-success w-auto m-auto" pButton (click)="onClickSubmit()" [disabled]="!isTermsAndConditionsSelected">Submit</button>
        </div>
    </ng-template>
</p-dialog>
<p-dialog [(visible)]="showThankyouModal" [modal]="true" [style]="{width: '50vw'}" header="Thank You"
    [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
    (onHide)="closeThankyou()">
    <div class="col-md-12 terms-form">
        Amount added to Wallet.
    </div>
</p-dialog>
<!-- <p-dialog [(visible)]="addCoinModal" [modal]="true" [style]="{width: '30vw'}" header="Add Coins"
    [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
    (onHide)="coinClose()">
    <form [formGroup]="addCoinForm" *ngIf="this.addCoinForm">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12">
                <label for="amount">Amount<span class="mandatory-fields">*</span></label>
                <input formControlName="amount" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': coinsubmitted && f1.amount.errors }">
                <div *ngIf="coinSubmitted && f1.amount.errors" class="invalid-feedback">
                    <div *ngIf="f1.amount.errors.required">Amount is required</div>
                    <div *ngIf="f1.amount.errors">Only Numbers allowed</div>
                </div>
            </div>
            <div class="p-field p-col-12">Note: 1 Cash equal to 10 Coins</div>
        </div>
        <button type="button" (click)="onCoinSubmit()" pButton icon="pi pi-check" label="Checkout"
            class="p-button-success save-btn p-mr-0" style="width: auto"></button>
    </form>
</p-dialog> -->

<p-dialog id="add-cash" header="Add Coin" [(visible)]="addCoinModal"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '500px' }" [modal]="true"
    [draggable]="false" [resizable]="false" (onHide)="coinClose()">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
    max-width: 100%;">
        <div class="modal-content">

            <div class="modal-body add-cash pay">
                <div class="card-body">
                    <div class="payment-info flex justify-space-between">
                        <div class="column shipping w-100">


                            <form [formGroup]="addCoinForm" *ngIf="this.addCoinForm">
                                <div class="container-fluid grid">
                                    <div class="row pull-center">
                                        <div class="col-md-12 ">
                                            <div class="wallet-screen" style="display: block;">
                                                <div class="total-amount">
                                                    <div class="wallet-icons">
                                                        <div class="icon">
                                                            <i class='bx bx-wallet-alt'></i>
                                                        </div>
                                                        <h1>Enter Amount</h1>
                                                    </div>
                                                    <div class="col-md-12 add-buttons">
                                                        <div class="add-money-form col-md-12">
                                                            <p-inputNumber mode="decimal" id="myInput2"
                                                                [useGrouping]="false" formControlName="amount"
                                                                [ngClass]="{ 'is-invalid': coinFormSubmitted && coinFormValidation.coin.errors }"
                                                                required placeholder="₹ 0">
                                                            </p-inputNumber>


                                                            <div *ngIf="coinFormSubmitted && coinFormValidation.coin.errors"
                                                                class="invalid-feedback">
                                                                <div *ngIf="coinFormValidation.coin.errors.required">
                                                                    Please enter cash value
                                                                </div>
                                                            </div>
                                                            <div *ngIf="showCoinError">
                                                                <span>Please add 100 Rs Or grater than 100 Rs.</span>
                                                            </div>

                                                        </div>
                                                        <div id="text-out">{{outputText}}</div>
                                                        <div class="col-md-12 text-center">
                                                            <button class="button button-primary"
                                                                (click)="onCoinSubmit()">Add to Wallet</button>


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-dialog>


<p-dialog id="Pay" [(visible)]="showBalanceModal" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }"
    [style]="{ width: '35.8rem' }" [modal]="true" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header" class="modal-header card-title">
        <span class="text-xl font-bold">Join Contest</span>
    </ng-template>
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" style="margin: 0px!important;    width: 100%;
        max-width: 100%;">
        <div class="modal-content">

            <div class="modal-body pay">
                <div class="card-body">
                    <div class="payment-info flex justify-space-between">
                        <div class="column shipping w-100">
                            <form action="#">
                                <div class="container-fluid grid">
                                    <div class="row pull-center">
                                        <div class="col-md-12 pp-none-mobile p-p-0">
                                            <div class="wallet-screen" style="display: block;">


                                                <div class="c-headline contest-player-details"
                                                    *ngFor="let contest of contestListData">
                                                    <h4 class="contest-main-div-userimage {{contest.tournamentName}} ">
                                                        <span class="apt-heading">
                                                            <div class="user-image">
                                                                <img src="{{contest.player1Image}}" alt=""
                                                                    class="single-div">
                                                                <!-- <p-avatarGroup styleClass="mb-1">
                                                                    <p-avatar
                                                                        image="assets/img/players/user-image-male.png"
                                                                        size="large" shape="circle"
                                                                        class="player-1-image"></p-avatar>
                                                                    <p-avatar
                                                                        image="assets/img/players/user-image-male.png"
                                                                        size="large" shape="circle"
                                                                        class="player-2-image"></p-avatar>
                                                                </p-avatarGroup> -->
                                                            </div>
                                                            <span class="palyer-name" [innerHTML]="contest.player1Name">
                                                            </span>
                                                        </span>
                                                        <span class="vs">Vs</span>
                                                        <span class="apt-heading">
                                                            <div class="user-image">
                                                                <img src="{{contest.player2Image}}" alt=""
                                                                    class="single-div">
                                                                <!-- <p-avatarGroup styleClass="mb-1">
                                                                    <p-avatar
                                                                        image="assets/img/players/user-image-male.png"
                                                                        size="large" shape="circle"
                                                                        class="player-1-image"></p-avatar>
                                                                    <p-avatar
                                                                        image="assets/img/players/user-image-male.png"
                                                                        size="large" shape="circle"
                                                                        class="player-2-image"></p-avatar>
                                                                </p-avatarGroup> -->
                                                            </div>
                                                            <span class="palyer-name" [innerHTML]="contest.player2Name">
                                                            </span>
                                                        </span>
                                                    </h4>
                                                    <!-- <div class="time-details">
                                                        <span>Match Start On:  {{contest.matchDate|date:'MMMM d, y, h:mm a'}} </span>
                                                    </div> -->
                                                    <div class="Price-details">
                                                        <h3>Prize Pool
                                                            <span
                                                                *ngIf="contest.updatedPoolCoins !== null && contest.updatedPoolCoins > 0">{{contest.updatedPoolCoins}}
                                                                TPL Coins
                                                            </span>
                                                            <span
                                                                *ngIf="contest.updatedPoolCash !== null && contest.updatedPoolCash > 0">{{contest.updatedPoolCash}}
                                                                Contest Cash
                                                            </span>
                                                        </h3>
                                                    </div>
                                                    <div class="match-details entery-fees">
                                                        <h3>Entry Fees:
                                                            <!-- <span *ngIf="userDetails?.age > 18" class="entry-fees-css">
                                                                {{entryCash}} TPL Cash OR
                                                            </span> -->
                                                            <span *ngIf="entryCash > 0" class="entry-fees-css">
                                                                {{entryCash}} Contest Cash
                                                            </span>
                                                            <span *ngIf="entryCash == 0" class="entry-fees-css">
                                                                Free
                                                            </span>
                                                        </h3>
                                                    </div>
                                                </div>

                                                <div class="total-amount">
                                                    <!-- <div class="wallet-icons">
                                                        <div class="icon">
                                                            <i class='bx bx-wallet-alt'></i>
                                                        </div>
                                                        <div class="payheader text-center">

                                                            <h1> Entry Fees</h1> -->

                                                    <!-- <h1>
                                <span style="font-size: 16px; margin-right: 2px;">₹</span>{{entryCash}}
                              </h1> -->
                                                    <!-- 
                                                        </div>
                                                        <h1> {{entryCash}} TPL Cash OR {{entryCoins}} TPL Coin</h1> -->
                                                    <!-- <div class="table-selectform w-100">
                                                            <table class="table table-bordered">
                                                                <thead>
                                                                    <tr>

                                                                        <th scope="col">Contest Name </th>
                                                                        <th scope="col">Players</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody *ngFor="let contest of contestListData">
                                                                    <tr>
                                                                        <td>{{contest.tournamentCategoryName}}</td>
                                                                        <td>{{contest.player1Name}}  VS  {{contest.player2Name}}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div> -->
                                                    <!-- <div class="modal-content" style="border:none;">

                                 <div *ngIf="selectedTournamentCategory && selectedAgeGroup && selectedEntryFees"
                                class="table-selectform w-100">
                              <table class="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th scope="col">Categories</th>
                                      <th scope="col">Age</th>
                                      <th scope="col">Entry Fees</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                   
                                    <tr *ngFor="let category of selectedTournamentCategory; index as i;">
                                      <td>{{ category.matchname }}</td>
                                      <td>{{ category.agegroupname }}</td>
                                      <td>Rs {{ selectedEntryFees[i] }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td></td>
                                      <td>
                                        <strong>Total</strong>
                                      </td>
                                      <td>
                                        <strong>₹{{ totalEntryFee() }}</strong>
                                      </td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div> 
                            </div>-->
                                                    <!-- </div> -->

                                                    <!-- <div class="col-md-12 add-buttons">
                                                        <div class="heading d-flex justify-content-center">
                                                            <h2 style="font-size: 11px;">TPL Contest Cash Available &nbsp;<span style="color: #20b033; font-size: 15px;">₹{{ tplCash }}</span></h2>
                                                        </div>
                                                    </div> -->

                                                    <!-- <div class="col-md-12 add-buttons mt-2 mb-4">
                                                        <div class="heading d-flex justify-content-between">
                                                            <div class="buttons">TPL Cash Convert To Money</div>
                                                            <h2>
                                                                <span
                                                                    class="addmore"
                                                                    (click)="convertCashToMoney()"> <i class="pi pi-arrow-right-arrow-left"></i> Convert </span>
                                                            </h2>
                                                        </div>
                                                    </div> -->

                                                    <div class="col-md-12 add-buttons">
                                                        <div class="heading d-flex justify-content-between">
                                                            <h2>Select Payment</h2>
                                                            <h2>
                                                                <span class="mobile-none-d"
                                                                    style=" font-family:'Krona One'; ">Available</span>
                                                                Balance
                                                            </h2>
                                                        </div>
                                                        <ul>
                                                            <form class="" [formGroup]="balanceForm"
                                                                *ngIf="this.balanceForm">


                                                                <li *ngFor="let tplCashOrCoin of tplCashCoinArr"
                                                                    class="tpl-cash">
                                                                    <label class="form-check-label"
                                                                        for="{{tplCashOrCoin.slug}}">
                                                                        <p-radioButton [value]="tplCashOrCoin.status"
                                                                            formControlName="{{tplCashOrCoin.slug}}"
                                                                            (onClick)="onTplCashOrCoinSelect(tplCashOrCoin, $event)"
                                                                            inputId="{{tplCashOrCoin.slug}}"></p-radioButton>
                                                                        <div class="buttons"> TPL {{tplCashOrCoin.name}}
                                                                            <span class="Balance"> <span
                                                                                    *ngIf="tplCashOrCoin.slug==='contestCash'"
                                                                                    class="Balance">₹</span>{{tplCashOrCoin.coinsOrCash}}
                                                                                <span
                                                                                    *ngIf="tplCashOrCoin.slug==='contestCash'"
                                                                                    class="addmore"
                                                                                    (click)="onClickAddCash()"> Load
                                                                                    Wallet </span>
                                                                                <!-- <span
                                                                                    *ngIf="tplCashOrCoin.slug==='coins' && userDetails?.age > 18"
                                                                                    class="addmore" (click)="addCoin()">
                                                                                    Load
                                                                                    Wallet </span> -->
                                                                            </span>
                                                                        </div>
                                                                    </label>


                                                                </li>
                                                            </form>
                                                        </ul>
                                                        <p *ngIf="showCashBalance && !showBalanceCashError"
                                                            class="cash-ms" style="display: block;">
                                                            After Transaction Your Balance Will Be
                                                            <span *ngIf="cashBalance > 0 ">
                                                                ₹ {{cashBalance}}
                                                            </span>
                                                            <span *ngIf="cashBalance <= 0 ">0 </span>Contest Cash
                                                        </p>
                                                        <p class="coin-ms"
                                                            *ngIf="showCoinBalance && !showBalanceCoinsError"
                                                            style="display: block;">After Transaction Your Balance
                                                            Will Be <span *ngIf="coinBalance > 0 ">{{coinBalance}}
                                                            </span>
                                                            <span *ngIf="coinBalance <= 0 ">0 </span> Coins
                                                        </p>
                                                        <div class="col-md-12 text-center">
                                                            <!-- <a href="quize-terms.html" class="button button-primary">
                Let's
                Play
            </a> -->
                                                            <div *ngIf="showBalanceCoinsError">
                                                                <span>Coin balance is low</span>
                                                            </div>
                                                            <div *ngIf="showBalanceCashError">
                                                                <span>Cash balance is low, Please add cash.</span>
                                                            </div>
                                                            <div *ngIf="showBalanceMoneyError">
                                                                <span>Please add Money to wallet or convert Cash to TPL Money.</span>
                                                            </div>
                                                            <div *ngIf="showPaymentSelectionError">
                                                                <span>Please select payment type.</span>
                                                            </div>

                                                        </div>
                                                        <!-- <div class="col-md-12 text-center"> -->
                                                        <!--a id="Entered-btn" class="button button-primary" (click)="thankyouModal(); isRegisterButtonEnabled()" [ngClass]="{ 'disabled-button': !isRegisterButtonEnabled() }"> Register </a-->
                                                        <!-- <a id="Entered-btn" class="button button-primary" (click)="thankyouModal()"
                                [ngClass]="{ 'disabled-button': !isRegisterButtonEnabled() }"> Register </a> -->
                                                        <!-- </div> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="modal-footer">

            <button (click)="onClickLetsPlay()" pButton [disabled]="letsPlayButtonDisabled">Lets
                Play</button>
        </div>
    </ng-template>
</p-dialog>

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <div class="col-md-12 main-title">
                    <h4> <span><i class='bx bx-filter-alt'></i></span> Filters</h4>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="left-side-section">
                    <div class="">

                        <div class="price-range fliter-div pt-2">
                            <div class="col-md-12 p-p-0 filter-lable-title">
                                <h6>Entry Fees </h6>
                                <button pButton label="Clear Filter" title="Clear Filter" class="p-button p-ml-2 p-mb-2"
                                (click)=" clear('price') "></button>
                            </div>
                            <form [formGroup]="pricerangeform">
                                <div class="price-rangefeild d-flex">
                                    <ul>
                                        <li>
                                            <span class="currency">₹</span>
                                            <input type="number" class="form-control" placeholder="Min Price" formControlName="minvalue"
                                            [ngClass]="{ 'is-invalid': entryFeeSubmitted && entryFeeC.minvalue.errors?.invalidRange }">
                                        </li>
                                        <li class="range-divider">-</li>
                                        <li class="smallrange-divider">
                                            <span>To</span>
                                        </li>
                                        <li>
                                            <span class="currency">₹</span>
                                            <input type="number" class="form-control" placeholder="Max Price" formControlName="maxvalue"
                                            [ngClass]="{ 'is-invalid': entryFeeSubmitted && entryFeeC.maxvalue.errors?.invalidRange }">
                                        </li>
                                        <li>
                                            <button
                                                    [disabled]="(entryFeeC.minvalue.errors && !entryFeeC.minvalue.errors?.invalidRange)"
                                                    (click)="onClickpricerange()">Go</button>
                                        </li>
                                    </ul>
                                    <div
                                        *ngIf="entryFeeSubmitted && entryFeeC.minvalue.errors?.invalidRange && entryFeeC.maxvalue.errors?.invalidRange">
                                        Min value cannot be greater than Max value
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="price-range fliter-div pt-2">
                            <div class="col-md-12 p-p-0 filter-lable-title">
                                <h6>Prize Pool </h6>
                                <button pButton label="Clear Filter" title="Clear Filter" class="p-button p-ml-2 p-mb-2"
                                (click)=" clear('poolPrice') "></button>
                            </div>
                            <div class="price-rangefeild coins d-flex">
                                <p-dropdown [options]="cashORcoin" [disabled]="under18" [showClear]="true" [(ngModel)]="cashOrCoinSelection"
                                (onChange)="onClickCashCoin($event)" optionLabel="name" [autoDisplayFirst]="false" placeholder="Select Prize Pool"></p-dropdown>

                                <form [formGroup]="poolPricerangeform">
                                    <ul *ngIf="poolCash" class="mt-3">
                                        <li>
    
                                            <input type="number" class="form-control" placeholder="Min Cash" value="1000" formControlName="minvalue">
                                        </li>
                                        <li class="range-divider">-</li>
                                        <li class="smallrange-divider">
                                            <span>To</span>
                                        </li>
                                        <li>
    
                                            <input type="number" class="form-control" placeholder="Max Cash" value="10000" formControlName="maxvalue">
                                        </li>
                                        <li>
                                            <button
                                                [disabled]="(poolPrice.minvalue.errors && !poolPrice.minvalue.errors?.invalidRange)"
                                                (click)="onClickPoolCash()">Go</button>
                                        </li>
                                    </ul>

                                    <ul *ngIf="!poolCash" class="mt-3">
                                        <li>

                                            <input type="number" class="form-control" placeholder="Min Coins"
                                                formControlName="minvalue"
                                                [ngClass]="{ 'is-invalid': poolCoinPriceSubmitted && poolPrice.minvalue.errors }">
                                        </li>
                                        <li class="range-divider">-</li>
                                        <li class="smallrange-divider">
                                            <span>To</span>
                                        </li>
                                        <li>

                                            <input type="number" class="form-control" placeholder="Max Coins"
                                                formControlName="maxvalue"
                                                [ngClass]="{ 'is-invalid': poolCoinPriceSubmitted && poolPrice.maxvalue.errors }">
                                        </li>
                                        <li
                                            [pTooltip]="(poolPrice.minvalue.errors && !poolPrice.minvalue.errors?.invalidRange) ? 'Enter min and max value' : ''">
                                            <button
                                                [disabled]="(poolPrice.minvalue.errors && !poolPrice.minvalue.errors?.invalidRange)"
                                                (click)="onClickPoolCoin()">Go</button>
                                        </li>
                                    </ul>
                                    <div
                                        *ngIf="poolCoinPriceSubmitted||poolCashPriceSubmitted && poolPrice.minvalue.errors?.invalidRange && poolPrice.maxvalue.errors?.invalidRange">
                                        Min value cannot be greater than Max value
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="fliter-div ">
                        <div class="col-md-12 p-p-0">
                            <h6>Sorting </h6>
                        </div>
                        <div class="Category d-flex mb-3">
                            <div class="short-by right-bar w-100">
                                <div class="default-shorting  w-100">

                                    <p-dropdown [options]="shorting" optionLabel="name" appendTo="body" placeholder="Select Sort By Price"
                                        autoZIndex="true" (onChange)="onClickSort($event)" [showClear]="true"></p-dropdown>


                                    <!-- <select class="form-select form-select-sm  w-100 "
                                        aria-label=".form-select-sm example">
                                        <option selected>Default sorting</option>
                                        <option value="1">Sort by popularity</option>
                                        <option value="2">Sort by average rating</option>
                                        <option value="3">Sort by latest</option>
                                        <option value="4">Sort by price: low to high</option>
                                        <option value="5">Sort by price: high to low</option>
                                    </select> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="fliter-div ">
                        <div class="col-md-12  p-p-0">
                            <h6>Type </h6>
                        </div>
                        <div class="Category d-flex mb-3">
                            <div class="short-by right-bar w-100">
                                <div class="default-shorting  w-100">
                                    <p-dropdown [options]="filterType" [showClear]="true" [(ngModel)]="type"
                                        (onChange)="onClickFreeOrPaid($event)" optionLabel="name"></p-dropdown>

                                    <!-- <select class="form-select form-select-sm  w-100 "
                                        aria-label=".form-select-sm example">
                                        <option selected>Select an option</option>
                                        <option value="1">Free</option>
                                        <option value="2">Paid</option>
                                    </select> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="fliter-div ">
                        <div class="col-md-12  p-p-0">
                            <h6>Contest Status </h6>
                        </div>
                        <div class="Category d-flex mb-3">
                            <div class="short-by right-bar w-100">
                                <div class="default-shorting  w-100">
                                    <p-dropdown [options]="contestMatchStatusArray" [showClear]="true" appendTo="body"
                                        [autoDisplayFirst]="false" placeholder="Select contest status"
                                        optionLabel="label" appendTo="body" autoZIndex="true" baseZIndex="999999999 "
                                        (onChange)="onChangeContestStatus($event)"></p-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="fliter-div ">
                        <div class="col-md-12  p-p-0">
                            <h6>Contest Status </h6>
                        </div>
                        <div class="Category d-flex mb-3">
                            <div class="short-by right-bar w-100">
                                <div class="default-shorting  w-100">
                                    <p-dropdown [options]="contestMatchStatusArray" optionLabel="label" appendTo="body"
                                        autoZIndex="true" baseZIndex="999999999 "
                                        (onChange)="onChangeContestStatus($event)"></p-dropdown>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="modal-footer filter-button d-flex justify-content-center">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close">Apply</button>
            </div>
            <!-- <div class="modal-footer filter-button">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Clear All</button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Apply</button>
            </div> -->
        </div>
    </div>
</div>

<p-dialog id="completeProfile" [(visible)]="welcomeLogin"
  [breakpoints]="{ '960px': '500px', '768px': 'calc(100% - 60px)', '389px': 'calc(100% - 30px)' }"
  [style]="{ width: '500px' }" [modal]="true" [draggable]="false" [resizable]="false"
  (onHide)="hideWelcomeLoginDialog()">
  <div class="Welcome-popup">
    <h4>
      Complete Your Profile!
    </h4>
    <p>You are required to complete your profile to proceed further</p>
    <hr class="line-div">
    <div class="actionButton">
      <div class="completeProfile_Button">
        <button type="button" *ngIf="contest?.updatedPoolCash > 0" [routerLink]="(!isContestVerified) ? '/profile-edit2' : '/dob-verification'" [queryParams]="{ isAbout18: isAbove18Check, page : 'contest'}">Complete Profile</button>
        <button type="button" *ngIf="contest?.updatedPoolCoins > 0" routerLink="/profile-edit2" [queryParams]="{ page : 'contest'}">Complete Profile</button>
    </div>
      <div class="skip_Button">
        <button (click)="hideWelcomeLoginDialog()">Cancel</button>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog header="Contest Prize Pool Structure " [(visible)]="priceStructurePopup" [modal]="true"
    class="prize-pool-structure terms-pricepool" [style]="{ width: '30%' }" [draggable]="false" [resizable]="false"
    id="poolStructurePopup2" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }">
    <div class="col-md-12 p-p-0">
        <div class="big-content">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col" class="entries-position">Position</th>
                    <th scope="col" class="entries-position">2 to 4 Entries</th>
                    <th scope="col" class="entries-position">5 to 7 Entries</th>
                    <th scope="col" class="entries-position">8 to 10 Entries</th>
                    <th scope="col" class="entries-position">11 to 13  Entries</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th scope="row" class="entries-position">1st</th>
                    <td class="table-data">100%</td>
                    <td class="table-data">65%</td>
                    <td class="table-data">50%</td>
                    <td class="table-data">40%</td>
                </tr>
                <tr>
                    <th scope="row" class="entries-position">2nd</th>
                    <td class="table-data">-</td>
                    <td class="table-data">35%</td>
                    <td class="table-data">30%</td>
                    <td class="table-data">30%</td>
                </tr>
                <tr>
                    <th scope="row" class="entries-position">3rd</th>
                    <td class="table-data">-</td>
                    <td class="table-data">-</td>
                    <td class="table-data">20%</td>
                    <td class="table-data">20%</td>
                </tr>
                <tr>
                    <th scope="row" class="entries-position">4th</th>
                    <td class="table-data">-</td>
                    <td class="table-data">-</td>
                    <td class="table-data">-</td>
                    <td class="table-data">10%</td>
                </tr>
            </tbody>
        </table>
        </div>
        <!-- <div class="col-md-12 headings-td">
<h3>STRICTLY CONFIDENTIAL</h3>
</div> -->
        <div class="big-content">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col" class="entries-position">Position</th>
                        <th scope="col" class="entries-position">14 to 18 Entries</th>
                        <th scope="col" class="entries-position">19 to 27 Entries</th>
                        <th scope="col" class="entries-position">28 to 36 Entries</th>
                        <th scope="col" class="entries-position">37 to 50 Entries</th>
                        <th scope="col" class="entries-position">51+ Entries</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row" class="entries-position">1st</th>
                        <td class="table-data">40%</td>
                        <td class="table-data">33%</td>
                        <td class="table-data">29%</td>
                        <td class="table-data">28%</td>
                        <td class="table-data">27%</td>
                    </tr>
                    <tr>
                        <th scope="row" class="entries-position">2nd</th>
                        <td class="table-data">23%</td>
                        <td class="table-data">20%</td>
                        <td class="table-data">18%</td>
                        <td class="table-data">16%</td>
                        <td class="table-data">15%</td>
                    </tr>
                    <tr>
                        <th scope="row" class="entries-position">3rd</th>
                        <td class="table-data">16%</td>
                        <td class="table-data">15%</td>
                        <td class="table-data">14%</td>
                        <td class="table-data">13%</td>
                        <td class="table-data">13%</td>
                    </tr>
                    <tr>
                        <th scope="row" class="entries-position">4th</th>
                        <td class="table-data">12%</td>
                        <td class="table-data">11%</td>
                        <td class="table-data">11%</td>
                        <td class="table-data">10%</td>
                        <td class="table-data">10%</td>
                    </tr>
                    <tr>
                        <th scope="row" class="entries-position">5th</th>
                        <td class="table-data">9%</td>
                        <td class="table-data">8%</td>
                        <td class="table-data">9%</td>
                        <td class="table-data">9%</td>
                        <td class="table-data">9%</td>
                    </tr>
                    <tr>
                        <th scope="row" class="entries-position">6th</th>
                        <td class="table-data">-</td>
                        <td class="table-data">7%</td>
                        <td class="table-data">8%</td>
                        <td class="table-data">8%</td>
                        <td class="table-data">8%</td>
                    </tr>
                    <tr>
                        <th scope="row" class="entries-position">7th</th>
                        <td class="table-data">-</td>
                        <td class="table-data">6%</td>
                        <td class="table-data">6%</td>
                        <td class="table-data">7%</td>
                        <td class="table-data">7%</td>
                    </tr>
                    <tr>
                        <th scope="row" class="entries-position">8th</th>
                        <td class="table-data">-</td>
                        <td class="table-data">-</td>
                        <td class="table-data">5%</td>
                        <td class="table-data">5%</td>
                        <td class="table-data">5%</td>
                    </tr>
                    <tr>
                        <th scope="row" class="entries-position">9th</th>
                        <td class="table-data">-</td>
                        <td class="table-data">-</td>
                        <td class="table-data">-</td>
                        <td class="table-data">4%</td>
                        <td class="table-data">4%</td>
                    </tr>
                    <tr>
                        <th scope="row" class="entries-position">10th</th>
                        <td class="table-data">-</td>
                        <td class="table-data">-</td>
                        <td class="table-data">-</td>
                        <td class="table-data">-</td>
                        <td class="table-data">2%</td>
                    </tr>
                </tbody>

            </table>
        </div>

    </div>
</p-dialog>

<p-confirmDialog [style]="{width: '500px'}"></p-confirmDialog>